<template>
    <div class="row p-xs">
      <div class="col-md-7">
        <strong>{{ statLabel }}:</strong>
      </div>
      <div class="col-md-5">
        <span class="label label-success">{{ statValue }}</span>
      </div>
    </div>
</template>

<script>

export default {
  name: 'StreamOverViewStat',

  props: {
    statLabel: {
      type: String,
      default: '',
    },
    statValue: {
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// StreamingOverviewItem.vue?8aa712ac